import React, { useContext } from "react";
import "../../../ui-styles/sliders/RightFullSlider.css";
import PatientProfileView from "./PatientProfieView";
import { LangCtx } from "../../../lib/context";

const ViewProfileSide = (props) => {
    const { l } = useContext(LangCtx);

    return (
        <div className={props.viewDetails ? "rightFullSlider rightSliderIn" : "rightFullSlider"}>
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>{l.pro_view}</span>
                    </div>
                    <div className="hdrActionGroup" onClick={props.handleView}>
                        <div className="hdrActItem close"></div>
                    </div>
                </div>
            </div>
            <div className="rightSliderBdy">
                <PatientProfileView data={props.data}/>
            </div>
        </div>
    )
}
export default ViewProfileSide;